import { gql } from '@apollo/client';

const TEST_API_PROJECTS = gql`
    query TestApiProjects($profileId: Int!, $pagination: PaginationOffsetInput!) {
        testApiProjects(profileId: $profileId, pagination: $pagination) {
            projects {
                id
                name
                language1 {
                    id
                    code
                    name
                    nativeName
                }
                language2 {
                    id
                    code
                    name
                    nativeName
                }
                enabledProducts {
                    id
                    name
                    colourTheme
                }
                isTestApiProject
            }
            paginationInfo {
                perPage
                maxPage
                currentPage
                totalCount
                previousPage
            }
        }
    }
`;

export default TEST_API_PROJECTS;
